// marketing namespace strings — EN + ES. Missing ES keys fall back to EN.
const STRINGS = {
  en: {
    // Nav
    "nav.features": "Features",
    "nav.business_types": "Business Types",
    "nav.pricing": "Pricing",
    "nav.login": "Login",
    "nav.live_demo": "Live Demo",
    "nav.start_trial": "Start Free Trial",
    "nav.toggle_to_spanish": "Ver en Español",
    "nav.toggle_to_english": "View in English",

    // Footer
    "footer.product": "Product",
    "footer.company": "Company",
    "footer.legal": "Legal",
    "footer.changelog": "What's new",
    "footer.business_types": "For your business",
    "footer.compare": "Compare",
    "footer.tagline": "Party rental software built by rental owners, for rental owners.",
    "footer.copyright": "© {year} PartyRentalSuite. All rights reserved.",

    // Home hero
    "home.hero.badge": "Built by rental owners, for rental owners",
    "home.hero.headline": "The only rental platform that thinks like a rental owner.",
    "home.hero.subheadline": "Bookings, waivers, weather alerts, drivers, marketing, multi-site — in one tool. None of the spreadsheets. Zero of the \u201Chey did we get the deposit yet?\u201D",
    "home.hero.primary_cta": "Try the live demo — no signup",
    "home.hero.secondary_cta": "See all features",

    // Benefit chips
    "home.chip.one_tool.label": "One tool.",
    "home.chip.one_tool.sub": "Website, bookings, waivers, drivers — all in one.",
    "home.chip.mobile.label": "Mobile-first.",
    "home.chip.mobile.sub": "Customers, owners, drivers — everyone's on a phone.",
    "home.chip.trial.label": "14-day trial.",
    "home.chip.trial.sub": "No credit card. Cancel anytime.",
    "home.chip.ships.label": "Ships weekly.",
    "home.chip.ships.sub": "New features every sprint — see the live changelog.",

    // Home — "Three things nobody else does well"
    "home.three.eyebrow": "What makes us different",
    "home.three.heading": "Three things nobody else does well.",
    "home.three.subhead": "Most rental software is a repurposed e-commerce cart. We were built specifically for the rental business — which means we actually solve the problems that keep you up at night.",
    "home.three.card1.title": "Weather-aware calendar",
    "home.three.card1.desc": "High winds over 15 mph on Saturday's bounce house delivery? We flag it on the calendar — before your customer is standing in a puddle.",
    "home.three.card2.title": "Multi-site, shared inventory",
    "home.three.card2.desc": "Photo booth site, foam party site, bounce house site — each built for its customer. Shared inventory = upsells across all three.",
    "home.three.card3.title": "AI that works while you sleep",
    "home.three.card3.desc": "Quotes go out polished. Follow-ups fire on schedule. Marketing copy rewrites itself. You focus on the next job, not the inbox.",
    "home.three.cta": "See all 42 features",

    // Features teaser
    "home.features_teaser.eyebrow": "Everything in one place",
    "home.features_teaser.heading": "A single tool that runs the whole rental operation.",
    "home.features_teaser.subheading": "See the full tour of what's inside.",
    "home.features_teaser.cta": "See all features",

    // HowItWorks
    "home.how.eyebrow": "How it works",
    "home.how.heading": "From \u201CI'm thinking about it\u201D to \u201CI'm booking customers\u201D in an afternoon.",
    "home.how.step1.title": "Sign up in 2 minutes",
    "home.how.step1.desc": "Pick a starter pack (Bounce House, Foam Party, Photo Booth, or General). We spin up your website, booking flow, waivers, and email templates — already configured for your business type.",
    "home.how.step2.title": "Drop in your inventory",
    "home.how.step2.desc": "Add your units with photos, pricing, and availability rules. Point us at your old spreadsheet — or just start fresh. Either way, you're live faster than your Google Ads take to approve.",
    "home.how.step3.title": "Stop sweating the operations",
    "home.how.step3.desc": "Customers book online, deposits hit your Stripe, drivers see their day on their phone, waivers get signed at checkout. You run the business — we run the admin.",

    // CTASection (default)
    "home.cta.headline": "Stop managing. Start growing.",
    "home.cta.subhead": "Your competitors are still running their business out of a spreadsheet. Let them.",
    "home.cta.label": "Try the demo — no signup",

    // Pricing plan card labels (PricingPlans.js)
    "pricing.contact_sales": "Contact Sales",
    "pricing.start_trial": "Start Free Trial",
    "pricing.get_started": "Get Started",
    "pricing.trial_days": "{days}-Day Free Trial",
    "pricing.billed_annually": "${amount}/mo billed annually",
    "pricing.most_popular": "Most Popular",
    "pricing.alacarte_label": "À la carte add-ons",
    "pricing.section_ai": "AI-Powered Features",
    "pricing.section_ai_included": "INCLUDED",
    "pricing.section_seo": "SEO & Local Marketing",
    "pricing.section_platform": "Platform & Operations",
    "pricing.section_analytics_enterprise": "Analytics & Enterprise",
    "pricing.see_what_comes": "See all the features that come with this plan",
    "pricing.click_to_expand": "Click to see the full list",
    "pricing.click_to_collapse": "Click to collapse",
    "pricing.new_badge": "NEW",
    "pricing.faq_heading": "Frequently asked questions",
    "pricing.compare_plans": "Compare all plans",

    // Plan highlights — Starter
    "plan.hl.site_1": "1 Microsite + Custom Domain",
    "plan.hl.sites_2": "2 Microsites + Custom Domains",
    "plan.hl.sites_3": "3 Microsites + Custom Domains",
    "plan.hl.sites_unlimited": "Unlimited Microsites",
    "plan.hl.booking_system": "Full Booking & Checkout System",
    "plan.hl.inventory_25": "Up to 25 Inventory Items",
    "plan.hl.inventory_50": "Up to 50 Inventory Items",
    "plan.hl.inventory_100": "Up to 100 Inventory Items",
    "plan.hl.inventory_unlimited": "Unlimited Inventory Items",
    "plan.hl.stripe_deposits": "Stripe Payments & Deposits",
    "plan.hl.email_auto": "Automated Email Notifications",
    "plan.hl.ai_10": "10 AI Calls/Month",
    "plan.hl.ai_50": "50 AI Calls/Month",
    "plan.hl.ai_200": "200 AI Calls/Month",
    "plan.hl.ai_unlimited": "Unlimited AI Calls",
    "plan.hl.ai_seo_suggestions": "AI SEO Suggestions",
    "plan.hl.seo_dashboard_100": "100-Point SEO Dashboard",
    "plan.hl.staff_users_5": "5 Staff Users",
    "plan.hl.staff_users_15": "15 Staff Users",
    "plan.hl.staff_users_unlimited": "Unlimited Staff Users",
    "plan.hl.driver_app": "Driver Mobile App",
    "plan.hl.multi_zone": "Multi-Zone Delivery Scheduling",
    "plan.hl.auto_seo": "Auto-SEO on Item Creation",
    "plan.hl.ai_alt_text": "AI Image Alt Text",
    "plan.hl.funnel_tracking": "Conversion Funnels",
    "plan.hl.seo_trends": "SEO Historical Trends",
    "plan.hl.custom_domains_all": "Custom Domain on Every Site",
    "plan.hl.waivers_digital": "Digital Waivers at Checkout",
    "plan.hl.white_label": "White Label Branding",
    "plan.hl.priority_support": "Priority Support",
    "plan.hl.dedicated_manager": "Dedicated Account Manager",
    "plan.hl.custom_integrations": "Custom Integrations",
    "plan.hl.sla_uptime": "SLA & Uptime Guarantee",

    // Addons
    "addon.premium_seo": "Premium SEO Analytics",
    "addon.extra_microsites": "Additional Microsites",
    "addon.extra_staff": "Extra Staff Seats",

    // Generic
    "common.learn_more": "Learn more",
    "common.get_started": "Get started",
    "common.contact_us": "Contact us",
  },
  es: {
    // Nav
    "nav.features": "Funciones",
    "nav.business_types": "Tipos de Negocio",
    "nav.pricing": "Precios",
    "nav.login": "Iniciar Sesión",
    "nav.live_demo": "Demo en Vivo",
    "nav.start_trial": "Prueba Gratis",
    "nav.toggle_to_spanish": "Ver en Español",
    "nav.toggle_to_english": "Ver en Inglés",

    // Footer
    "footer.product": "Producto",
    "footer.company": "Empresa",
    "footer.legal": "Legal",
    "footer.changelog": "Novedades",
    "footer.business_types": "Para tu Negocio",
    "footer.compare": "Comparar",
    "footer.tagline": "Software de alquiler de fiestas creado por dueños de negocios, para dueños de negocios.",
    "footer.copyright": "© {year} PartyRentalSuite. Todos los derechos reservados.",

    // Home hero
    "home.hero.badge": "Creado por dueños de alquileres, para dueños de alquileres",
    "home.hero.headline": "La única plataforma de alquiler que piensa como un operador.",
    "home.hero.subheadline": "Reservas, responsabilidades, alertas del clima, choferes, marketing, multi-sitio — en una sola herramienta. Sin hojas de cálculo. Sin preguntarse \u201C¿ya llegó el depósito?\u201D",
    "home.hero.primary_cta": "Prueba el demo — sin registro",
    "home.hero.secondary_cta": "Ver todas las funciones",

    // Benefit chips
    "home.chip.one_tool.label": "Una herramienta.",
    "home.chip.one_tool.sub": "Sitio web, reservas, responsabilidades, choferes — todo junto.",
    "home.chip.mobile.label": "Primero el móvil.",
    "home.chip.mobile.sub": "Clientes, dueños, choferes — todos desde su teléfono.",
    "home.chip.trial.label": "14 días de prueba.",
    "home.chip.trial.sub": "Sin tarjeta de crédito. Cancela cuando quieras.",
    "home.chip.ships.label": "Actualizaciones semanales.",
    "home.chip.ships.sub": "Nuevas funciones cada sprint — mira el historial en vivo.",

    // Home — "Three things nobody else does well"
    "home.three.eyebrow": "Lo que nos hace diferentes",
    "home.three.heading": "Tres cosas que nadie más hace bien.",
    "home.three.subhead": "La mayoría de los softwares de alquiler son solo carritos de e-commerce reciclados. Nosotros fuimos diseñados específicamente para el negocio del alquiler — por eso realmente resolvemos los problemas que te quitan el sueño.",
    "home.three.card1.title": "Calendario con alertas del clima",
    "home.three.card1.desc": "¿Vientos fuertes de más de 15 mph el sábado cuando entregas el brincolín? Te lo marcamos en el calendario — antes de que tu cliente termine parado en un charco.",
    "home.three.card2.title": "Multi-sitio con inventario compartido",
    "home.three.card2.desc": "Un sitio para cabinas de foto, otro para fiestas de espuma, otro para brincolines — cada uno diseñado para su cliente. El inventario compartido significa ventas cruzadas en los tres.",
    "home.three.card3.title": "IA que trabaja mientras duermes",
    "home.three.card3.desc": "Las cotizaciones salen pulidas. Los seguimientos se disparan a tiempo. El copy de marketing se reescribe solo. Tú te enfocas en el próximo trabajo, no en la bandeja de entrada.",
    "home.three.cta": "Ver las 42 funciones",

    // Features teaser
    "home.features_teaser.eyebrow": "Todo en un solo lugar",
    "home.features_teaser.heading": "Una sola herramienta que maneja toda tu operación de alquiler.",
    "home.features_teaser.subheading": "Mira el recorrido completo de lo que incluye.",
    "home.features_teaser.cta": "Ver todas las funciones",

    // HowItWorks
    "home.how.eyebrow": "Cómo funciona",
    "home.how.heading": "De \u201Cestoy pensándolo\u201D a \u201Cya estoy tomando reservas\u201D en una tarde.",
    "home.how.step1.title": "Regístrate en 2 minutos",
    "home.how.step1.desc": "Elige un paquete inicial (Brincolines, Fiesta de Espuma, Cabina de Foto o General). Nosotros armamos tu sitio web, flujo de reservas, responsabilidades y plantillas de correo — ya configurados para tu tipo de negocio.",
    "home.how.step2.title": "Carga tu inventario",
    "home.how.step2.desc": "Agrega tus unidades con fotos, precios y reglas de disponibilidad. Pásanos tu vieja hoja de cálculo — o empieza desde cero. De cualquier forma, estás en vivo más rápido de lo que tardan en aprobarte un Google Ad.",
    "home.how.step3.title": "Deja de sudar la operación",
    "home.how.step3.desc": "Los clientes reservan en línea, los depósitos llegan a tu Stripe, los choferes ven su día en el teléfono, las responsabilidades se firman al pagar. Tú diriges el negocio — nosotros manejamos la oficina.",

    // CTASection
    "home.cta.headline": "Deja de administrar. Empieza a crecer.",
    "home.cta.subhead": "Tus competidores siguen manejando su negocio desde una hoja de cálculo. Déjalos ahí.",
    "home.cta.label": "Prueba el demo — sin registro",

    // Pricing plan card labels
    "pricing.contact_sales": "Contactar Ventas",
    "pricing.start_trial": "Prueba Gratis",
    "pricing.get_started": "Empezar",
    "pricing.trial_days": "{days} Días Gratis",
    "pricing.billed_annually": "${amount}/mes cobrado anualmente",
    "pricing.most_popular": "Más Popular",
    "pricing.alacarte_label": "Complementos à la carte",
    "pricing.section_ai": "Funciones con IA",
    "pricing.section_ai_included": "INCLUIDO",
    "pricing.section_seo": "SEO & Marketing Local",
    "pricing.section_platform": "Plataforma & Operaciones",
    "pricing.section_analytics_enterprise": "Analítica & Empresarial",
    "pricing.see_what_comes": "Ver todas las funciones incluidas en este plan",
    "pricing.click_to_expand": "Haz clic para ver la lista completa",
    "pricing.click_to_collapse": "Haz clic para colapsar",
    "pricing.new_badge": "NUEVO",
    "pricing.faq_heading": "Preguntas frecuentes",
    "pricing.compare_plans": "Comparar todos los planes",

    // Plan highlights
    "plan.hl.site_1": "1 Micrositio + Dominio Personalizado",
    "plan.hl.sites_2": "2 Micrositios + Dominios Personalizados",
    "plan.hl.sites_3": "3 Micrositios + Dominios Personalizados",
    "plan.hl.sites_unlimited": "Micrositios Ilimitados",
    "plan.hl.booking_system": "Sistema Completo de Reservas y Pago",
    "plan.hl.inventory_25": "Hasta 25 Artículos de Inventario",
    "plan.hl.inventory_50": "Hasta 50 Artículos de Inventario",
    "plan.hl.inventory_100": "Hasta 100 Artículos de Inventario",
    "plan.hl.inventory_unlimited": "Inventario Ilimitado",
    "plan.hl.stripe_deposits": "Pagos y Depósitos por Stripe",
    "plan.hl.email_auto": "Notificaciones por Correo Automatizadas",
    "plan.hl.ai_10": "10 Llamadas de IA / Mes",
    "plan.hl.ai_50": "50 Llamadas de IA / Mes",
    "plan.hl.ai_200": "200 Llamadas de IA / Mes",
    "plan.hl.ai_unlimited": "Llamadas de IA Ilimitadas",
    "plan.hl.ai_seo_suggestions": "Sugerencias SEO con IA",
    "plan.hl.seo_dashboard_100": "Panel SEO de 100 Puntos",
    "plan.hl.staff_users_5": "5 Usuarios de Personal",
    "plan.hl.staff_users_15": "15 Usuarios de Personal",
    "plan.hl.staff_users_unlimited": "Usuarios de Personal Ilimitados",
    "plan.hl.driver_app": "App Móvil para Choferes",
    "plan.hl.multi_zone": "Programación de Entrega Multi-Zona",
    "plan.hl.auto_seo": "Auto-SEO al Crear Artículos",
    "plan.hl.ai_alt_text": "Textos Alternativos de Imagen con IA",
    "plan.hl.funnel_tracking": "Embudos de Conversión",
    "plan.hl.seo_trends": "Tendencias Históricas de SEO",
    "plan.hl.custom_domains_all": "Dominio Propio en Cada Sitio",
    "plan.hl.waivers_digital": "Exenciones Digitales al Pagar",
    "plan.hl.white_label": "Marca Blanca",
    "plan.hl.priority_support": "Soporte Prioritario",
    "plan.hl.dedicated_manager": "Gerente de Cuenta Dedicado",
    "plan.hl.custom_integrations": "Integraciones Personalizadas",
    "plan.hl.sla_uptime": "Garantía de SLA y Tiempo Activo",

    // Addons
    "addon.premium_seo": "Analítica SEO Premium",
    "addon.extra_microsites": "Micrositios Adicionales",
    "addon.extra_staff": "Asientos de Personal Extra",

    // Generic
    "common.learn_more": "Más información",
    "common.get_started": "Empezar",
    "common.contact_us": "Contáctanos",
  },
};

export default STRINGS;
